import React, { useState, useEffect } from 'react';
import { Statistic } from 'antd';
import PropTypes from 'prop-types';


const { Countdown } = Statistic;

const defaultCountdownFormat = 'D [days] H [hours] m [minutes]';
const secondsCountdownFormat = 'D [days] H [hours] m [minutes] s [sec]';
const TestCountdown = ({ endTime, onExpire }) => {
    const [isLastFiveMinutes, setIsLastFiveMinutes] = useState(false);
    const [countdownFormat, setCountdownFormat] = useState(defaultCountdownFormat);
    const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

    const handleCountdownChange = (current) => {
        if (current <= FIVE_MINUTES_IN_MS && !isLastFiveMinutes) {
            setIsLastFiveMinutes(true);
        } else if (current > FIVE_MINUTES_IN_MS && isLastFiveMinutes) {
            setIsLastFiveMinutes(false);
        }
    };

    useEffect(() => {
        if(isLastFiveMinutes) {
            setCountdownFormat(secondsCountdownFormat);
        } else {
            setCountdownFormat(defaultCountdownFormat);
        }
    }, [isLastFiveMinutes]);

    return (
        <Countdown
            value={endTime}
            onFinish={onExpire}
            format={countdownFormat}
            prefix="Expires in: "
            onChange={handleCountdownChange}
            className={isLastFiveMinutes ? 'ch-expired' : ''}
        />
    );
};


TestCountdown.propTypes = {
    endTime: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.number,
    ]).isRequired,
    onExpire: PropTypes.func,
};

export default TestCountdown;
